module.exports = __webpack_public_path__ + "assets/img/25_401.755abfb7.jpg";